import { ArrowBack } from '@mui/icons-material'
import { Card, CardContent, CardHeader, Container, Grid, IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { getDataWithResponse } from 'global/getFunc'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MapSingle from 'examples/Maps/MapSingle'
import Monev from 'pages/superAdmin/Monev'

const Komponen = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const id = location.state;
    const [data, setData] = useState({});

    const [opd, setOpd] = useState({})
    const [basemap] = useState('streets-navigation-vector')

    useEffect(() => {
        reqKomponen();
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps, no-use-before-define
    }, [])

    const reqKomponen = () => {
        getDataWithResponse(
            `/komponen-belanja/show/${id}`,
            null,
            (res) => {
                setData(res)
                console.log(res);
            },
            (res) => {
                console.log(res)
            }
        )
    }

    const reqOpd = () => {
        getDataWithResponse(
            `/opd/show/${data.kd_pd}`,
            null,
            (res) => {
                setOpd(res)
                console.log(res);
            },
            (res) => {
                console.log(res)
            }
        )
    }

    useEffect(() => {
        data.kd_pd !== undefined && reqOpd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    return (
        <Container sx={{ my: 10 }}>
            <ArgonBox mt={2}>
                <Grid container spacing={2} my={2}>
                    <Grid item xs={12} xl={12}>
                        <ArgonTypography>DETAIL PEKERJAAN</ArgonTypography>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mt={2}>
                <ArgonBox mb={3}>
                    <Card>
                        <CardHeader
                            title={
                                <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                            }
                            avatar={
                                <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack fontSize='small' /></IconButton>
                            }
                        />
                        <CardContent>
                            <Table aria-label="simple table">
                                <TableBody>
                                    <TableRow key={0} >
                                        <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                        <TableCell sx={{ fontSize: 'small' }}>: {data.ta}</TableCell>
                                    </TableRow>
                                    <TableRow key={1} >
                                        <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                        <TableCell sx={{ fontSize: 'small' }}>: {opd.kd_pd} {opd.nama_pd}</TableCell>
                                    </TableRow>
                                    <TableRow key={7} >
                                        <TableCell sx={{ fontSize: 'small' }}>Komponen</TableCell>
                                        <TableCell sx={{ fontSize: 'small' }}>: {data.nama_komponen}</TableCell>
                                    </TableRow>
                                    <TableRow key={9} >
                                        <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                        <TableCell sx={{ fontSize: 'small' }}>
                                            : {
                                                parseInt(data.anggaran).toLocaleString?.('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })
                                            }
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </ArgonBox>

                {
                    data.penerima_manfaat === 'Off Site' &&
                    <>
                        <Monev
                            komponenData={data}
                            allowEdit={false}
                        />


                        {
                            data.geometry_type !== '' &&
                            <ArgonBox>
                                <Card sx={{ height: '500px' }}>
                                    {/* <CardContent sx={{ height: '90vh' }}> */}
                                    <MapSingle
                                        data={data}
                                        basemap={basemap}
                                    />
                                    {/* </CardContent> */}
                                </Card>
                            </ArgonBox>
                        }
                    </>

                }

            </ArgonBox>
        </Container>
    )
}

export default Komponen